import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=e6aa70d8&"
import script from "./EditView.vue?vue&type=script&lang=js&"
export * from "./EditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports